/* CONVETI by ESPEJOL */
(function () {
  'use strict';
  var d = document;
  var root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var body = d.body;
  function attr(name, fallback) { return (body && body.getAttribute(name)) || fallback; }
  var cartAdd = attr('data-cart-add', '/cart/add');
  var cartUrl = attr('data-cart-url', '/cart');
  var txtAdded = attr('data-i18n-added', 'Agregado a tu bolsa');
  var txtViewCart = attr('data-i18n-view-cart', 'Ver bolsa');
  var txtError = attr('data-i18n-error', 'No fue posible agregar la pieza.');

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function trackWhatsApp() {
    each(d.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]'), function (a) {
      a.addEventListener('click', function () {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'conversion', { send_to: 'AW-16897459775/MaqYCIH_qLAaEL-Mq_k-' });
        }
      });
    });
  }

  function initHeader() {
    var h = d.querySelector('[data-cv-header]');
    if (!h) return;
    var overlay = h.classList.contains('cv-header--overlay');
    var toggle = h.querySelector('[data-cv-menu-toggle]');
    var menu = h.querySelector('[data-cv-menu]');
    function onScroll() {
      if (!overlay) return;
      h.classList.toggle('is-solid', window.scrollY > 24);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (!toggle || !menu) return;
    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.hidden = !open;
      h.classList.toggle('is-open', open);
      root.classList.toggle('cv-lock', open);
      if (open) { var first = menu.querySelector('a'); if (first) first.focus(); }
    }
    toggle.addEventListener('click', function () { setOpen(toggle.getAttribute('aria-expanded') !== 'true'); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { setOpen(false); toggle.focus(); } });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990 && !menu.hidden) setOpen(false); });
  }

  function initReveal() {
    var items = d.querySelectorAll('[data-cv-reveal]');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) { each(items, function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    each(items, function (el) { io.observe(el); });
  }

  function initVideos() {
    each(d.querySelectorAll('[data-cv-video]'), function (wrap) {
      var v = wrap.querySelector('video');
      if (!v) return;
      var btn = wrap.querySelector('[data-cv-video-toggle]');
      var userPaused = false;
      v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      function label(playing) {
        if (!btn) return;
        btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        var s = btn.querySelector('span');
        if (s) s.textContent = playing ? btn.getAttribute('data-pause') : btn.getAttribute('data-play');
      }
      function play() {
        var p = v.play();
        if (p && p.then) p.then(function () { label(true); }).catch(function () { label(false); });
      }
      v.addEventListener('playing', function () { wrap.classList.add('is-playing'); label(true); });
      v.addEventListener('pause', function () { label(false); });
      if (btn) {
        btn.addEventListener('click', function () {
          if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); }
        });
      }
      label(false);
      if (reduce || saveData || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { if (!userPaused) play(); } else if (!v.paused) { v.pause(); }
        });
      }, { threshold: 0.25 });
      io.observe(wrap);
    });
  }

  function initExplorer() {
    each(d.querySelectorAll('[data-cv-explorer]'), function (ex) {
      var items = Array.prototype.slice.call(ex.querySelectorAll('[data-cv-item]'));
      if (!items.length) return;
      var formBtns = ex.querySelectorAll('[data-cv-form]');
      var finBtns = Array.prototype.slice.call(ex.querySelectorAll('[data-cv-finish]'));
      var viewBtns = ex.querySelectorAll('[data-cv-view]');
      var descs = ex.querySelectorAll('[data-cv-form-desc]');
      var card = ex.querySelector('[data-cv-card-target]');
      var tag = ex.querySelector('[data-cv-live]');
      var stage = ex.querySelector('[data-cv-stage]');
      var ambientLabel = ex.getAttribute('data-ambient-label') || '';
      var pref = ex.getAttribute('data-default-finish') || '';
      var start = items.filter(function (i) { return i.getAttribute('data-finish') === pref; })[0] || items[0];
      var state = { form: start.getAttribute('data-form'), finish: start.getAttribute('data-finish'), view: 'piece' };
      function find(form, finish) {
        return items.filter(function (i) { return i.getAttribute('data-form') === form && i.getAttribute('data-finish') === finish; })[0];
      }
      function available(form) {
        return finBtns.filter(function (b) { return !!find(form, b.getAttribute('data-cv-finish')); });
      }
      function render() {
        var it = find(state.form, state.finish);
        if (!it) { var av = available(state.form); if (av.length) { state.finish = av[0].getAttribute('data-cv-finish'); it = find(state.form, state.finish); } }
        items.forEach(function (i) {
          var on = i === it;
          i.classList.toggle('is-active', on);
          i.classList.toggle('is-ambient', state.view === 'ambient');
          i.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) each(i.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
        });
        each(formBtns, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cv-form') === state.form ? 'true' : 'false'); });
        finBtns.forEach(function (b) {
          var f = b.getAttribute('data-cv-finish');
          b.disabled = !find(state.form, f);
          b.setAttribute('aria-pressed', f === state.finish ? 'true' : 'false');
        });
        each(viewBtns, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cv-view') === state.view ? 'true' : 'false'); });
        each(descs, function (x) { x.hidden = x.getAttribute('data-cv-form-desc') !== state.form; });
        if (it) {
          var tpl = it.querySelector('template');
          if (card && tpl) card.innerHTML = tpl.innerHTML;
          if (tag) tag.textContent = it.getAttribute('data-label') + (state.view === 'ambient' && ambientLabel ? ' \u00b7 ' + ambientLabel : '');
        }
      }
      each(formBtns, function (b) { b.addEventListener('click', function () { state.form = b.getAttribute('data-cv-form'); render(); }); });
      finBtns.forEach(function (b) { b.addEventListener('click', function () { state.finish = b.getAttribute('data-cv-finish'); render(); }); });
      each(viewBtns, function (b) { b.addEventListener('click', function () { state.view = b.getAttribute('data-cv-view'); render(); }); });
      if (stage) {
        var sx = null, sy = null;
        stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
        stage.addEventListener('pointerup', function (e) {
          if (sx === null) return;
          var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          var av = available(state.form);
          var idx = av.map(function (b) { return b.getAttribute('data-cv-finish'); }).indexOf(state.finish);
          idx = (idx + (dx < 0 ? 1 : -1) + av.length) % av.length;
          state.finish = av[idx].getAttribute('data-cv-finish');
          render();
        });
        stage.addEventListener('pointercancel', function () { sx = null; });
      }
      render();
    });
  }

  function initFilter() {
    each(d.querySelectorAll('[data-cv-grid]'), function (grid) {
      var section = grid.closest('section');
      var btns = section ? section.querySelectorAll('[data-cv-filter]') : [];
      each(btns, function (b) {
        b.addEventListener('click', function () {
          var f = b.getAttribute('data-cv-filter');
          each(btns, function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          grid.classList.toggle('is-filtered', f !== 'all');
          each(grid.querySelectorAll('[data-cv-card]'), function (c) { c.hidden = f !== 'all' && c.getAttribute('data-form') !== f; });
          each(grid.querySelectorAll('[data-cv-pause]'), function (p) { p.hidden = f !== 'all'; });
        });
      });
    });
  }

  function updateCount(n) {
    each(d.querySelectorAll('[data-cv-cart-count]'), function (el) { el.textContent = n; });
  }

  function initProduct() {
    each(d.querySelectorAll('[data-cv-product]'), function (wrap) {
      var jsonEl = wrap.querySelector('[data-cv-json]');
      var form = wrap.querySelector('form[action*="/cart/add"]');
      if (!jsonEl || !form) return;
      var data;
      try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var idInput = form.querySelector('[data-cv-variant]');
      var prices = wrap.querySelectorAll('[data-cv-price]');
      var addBtns = wrap.querySelectorAll('[data-cv-add]');
      var status = wrap.querySelector('[data-cv-status]');
      var fieldsets = form.querySelectorAll('[data-cv-option]');

      function selected() {
        return Array.prototype.map.call(fieldsets, function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      }
      function match(opts) {
        return data.variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); })[0];
      }
      function setButtons(v) {
        each(addBtns, function (b) {
          var ok = !!(v && v.available);
          b.disabled = !ok;
          var l = b.querySelector('[data-cv-add-label]');
          if (l) l.textContent = ok ? b.getAttribute('data-add') : (v ? b.getAttribute('data-soldout') : b.getAttribute('data-unavailable'));
        });
      }
      function update() {
        each(fieldsets, function (fs) {
          var c = fs.querySelector('input:checked');
          var l = fs.querySelector('[data-cv-option-value]');
          if (c && l) l.textContent = c.getAttribute('data-label') || c.value;
        });
        var v = match(selected());
        setButtons(v);
        if (!v) return;
        idInput.value = v.id;
        each(prices, function (p) { p.textContent = v.price; });
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u.toString()); } catch (e) {}
      }
      form.addEventListener('change', function (e) { if (e.target.closest('[data-cv-option]')) update(); });

      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        each(addBtns, function (b) { b.setAttribute('aria-busy', 'true'); });
        if (status) status.textContent = '';
        fetch(cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || txtError); return j; });
        }).then(function () {
          return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        }).then(function (c) {
          updateCount(c.item_count);
          if (status) {
            status.textContent = txtAdded + ' \u00b7 ';
            var a = d.createElement('a'); a.href = cartUrl; a.textContent = txtViewCart;
            status.appendChild(a);
          }
        }).catch(function (err) {
          if (status) status.textContent = err.message || txtError;
        }).then(function () {
          each(addBtns, function (b) { b.removeAttribute('aria-busy'); });
        });
      });

      var track = wrap.querySelector('[data-cv-track]');
      var count = wrap.querySelector('[data-cv-count]');
      if (track && count) {
        track.addEventListener('scroll', function () {
          if (!track.clientWidth) return;
          count.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1;
        }, { passive: true });
      }

      var sticky = wrap.querySelector('[data-cv-sticky]');
      var mainBtn = wrap.querySelector('.cv-pinfo [data-cv-add]');
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var show = !en.isIntersecting;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
            each(sticky.querySelectorAll('button'), function (b) { b.tabIndex = show ? 0 : -1; });
          });
        }).observe(mainBtn);
      }
    });
  }

  function init() {
    initHeader();
    initReveal();
    initVideos();
    initExplorer();
    initFilter();
    initProduct();
    trackWhatsApp();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
